<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 终端签收
        </el-breadcrumb-item>
        <el-breadcrumb-item>扫码签收记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="120px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="出库单号" prop="outBillCode">
                <el-input v-model.trim="searchform.outBillCode" style="width: 100%" clearable placeholder="请输入出库单号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="收货编码" prop="receiveCode">
                <el-input v-model.trim="searchform.receiveCode" style="width: 100%" clearable placeholder="请输入收货编码" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="签收单号" prop="sginBillCode">
                <el-input v-model.trim="searchform.sginBillCode" style="width: 100%" clearable placeholder="请输入签收单号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态" prop="status">
                <el-select v-model="searchform.status" placeholder="请选择">
                  <el-option label="所有" :value="-1"></el-option>
                  <el-option label="未签收" :value="0"></el-option>
                  <el-option label="已签收" :value="1"></el-option>
                  <el-option label="拒绝签收" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="用户类型" prop="userType">
                <el-select v-model="searchform.userType" placeholder="请选择">
                  <el-option label="所有" :value="-1"></el-option>
                  <el-option label="老板" :value="1"></el-option>
                  <el-option label="店长" :value="2"></el-option>
                  <el-option label="促销员" :value="4"></el-option>
                  <el-option label="业务员" :value="8"></el-option>
                  <el-option label="收货员" :value="16"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" v-permission="['sttSsignWeblist_select']"
                @click="search()">搜索</el-button>
              <!-- <el-button type="primary" v-loading="listLoading2" v-permission="['sttSsignWeblist_job']"
                @click="exportlist()">导出</el-button> -->
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br id="A1" />
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>扫码签收记录</h4>
          <el-divider></el-divider>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" style="width: 100%"
            id="parent">
            <el-table-column type="expand">
              <template slot-scope="props">
                <h4>单据产品</h4>
                <el-divider></el-divider>
                <el-table :data="props.row.products" style="width: 100%">
                  <el-table-column prop="productCode" label="产品编码" width="120">
                  </el-table-column>
                  <el-table-column prop="productName" label="产品名称" width="250">
                  </el-table-column>
                  <el-table-column prop="batchno" label="批次号" width="250">
                  </el-table-column>
                  <el-table-column prop="totQuantity" label="总数量" width="120">
                  </el-table-column>
                  <el-table-column prop="scanQuantity" label="扫码数量" width="120">
                  </el-table-column>
                  <el-table-column prop="countQuantity" label="计数数量" width="120">
                  </el-table-column>
                  <el-table-column prop="givenQuantity" label="赠送数量" width="120">
                  </el-table-column>
                  <el-table-column prop="salesQuantity" label="销售数量" width="120">
                  </el-table-column>
                  <el-table-column prop="givenTypeName" label="赠送类型" width="120">
                  </el-table-column>
                  <el-table-column min-width="260" property="actualProductCode" show-overflow-tooltip label="操作"
                    fixed="right">
                    <template slot-scope="props">
                      <el-button type="primary" @click="getterminalqrcodelist(props.row)"
                        v-permission="['sttSsignWeblist_select']">查看箱码</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="dealerCode" label="经销商编码" min-width="150" show-overflow-tooltip />
            <el-table-column prop="dealerName" label="经销商名称" min-width="150" show-overflow-tooltip /> -->
            <el-table-column prop="receiveCode" label="客户编码" min-width="150" show-overflow-tooltip />
            <el-table-column prop="receiveName" label="客户名称" min-width="150" show-overflow-tooltip />
            <el-table-column prop="sginUserName" label="签收人" min-width="150" show-overflow-tooltip />
            <el-table-column prop="sginUserTel" label="签收人手机号" min-width="150" show-overflow-tooltip />
            <el-table-column prop="createTime" label="建单时间" min-width="160" show-overflow-tooltip />
            <el-table-column prop="sginTime" label="签收时间" min-width="160" show-overflow-tooltip />
            <el-table-column prop="sginAddress" label="签收地址" min-width="160" show-overflow-tooltip />
            <el-table-column prop="deliveryTime" label="送达时间" min-width="160" show-overflow-tooltip />

            <el-table-column prop="deliveryAddress" label="送达地址" min-width="160" show-overflow-tooltip />

            <el-table-column prop="outBillCode" label="出库单号" min-width="140" show-overflow-tooltip />
            <el-table-column prop="receiveCode" label="收货编码" min-width="140" show-overflow-tooltip />

            <el-table-column prop="status" label="状态" min-width="140" show-overflow-tooltip />


          </el-table>

          <br />
          <el-pagination background @current-change="currentchange" @size-change="limit"
            :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 50]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
        </el-col>
      </el-row>


      <el-dialog title="箱码列表" :visible.sync="dialogVisible" width="70%">
        <el-table :data="boxcodelist" style="width: 100%" height="400">
          <el-table-column prop="productCode" label="产品编码" min-width="120">
          </el-table-column>
          <el-table-column prop="productName" label="产品名称" min-width="120">
          </el-table-column>
          <el-table-column prop="qrcode" label="箱码" min-width="120">
          </el-table-column>
          <el-table-column prop="sginBillCode" label="签收单" min-width="120">
          </el-table-column>
          <el-table-column prop="userTel" label="签收人手机号" min-width="120">
          </el-table-column>
          <el-table-column prop="scanTime" label="签收时间" min-width="120">
          </el-table-column>
        </el-table>
        <br />
        <!-- <el-pagination background @current-change="Boxcurrentchange" @size-change="Boxlimit"
          :current-page.sync="searchBoxcode.page" :page-sizes="[10, 20, 30, 50]"
          layout="total,prev, pager, next,jumper,sizes" :total="Boxtotal_count">
        </el-pagination> -->
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span> -->
      </el-dialog>

    </div>
  </div>
</template>
<script>
import { signorderlist, typeorglist, outbillorderimglist, terminalqrcodelist } from "@/api/out";
import axios from "axios";
import { getToken } from "@/utils/auth";
//引入导出组件模块
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.search();
    this.getmarkentinglist("", 0);
  },
  data() {
    return {
      //基础数据
      add: {
        addshow: false,
      },
      listLoading2: false,
      listLoading: false,
      tableData: [],
      productlist: [], //单据产品列表
      marketinglist: [],
      businesslist: [],
      regionlist: [],
      //分页数据
      limits: "",
      total_count: 0,
      currentPage: 1,
      imglist: [],
      searchform: {
        dealerCode: "",
        businessCode: "",
        regionCode: "",
        marketingCode: "",
        limit: 10,
        outBillCode: "",
        page: 1,
        receiveCode: "",
        datelist: null,
        datelist1: null,
        startCreateTime: "",
        endCreateTime: "",
        endSginTime: "",
        startSginTime: "",
        status: -1,
      },
      searchBoxcode: {
        "productCode": "string",
        "sginBillCode": "string"
      },
      boxcodelist: [],
      Boxtotal_count: 0,
      dialogVisible: false
    };
  },
  methods: {
    exportlist() {
      this.llistLoading2 = true;
      let obj = this.searchform;
      obj.limit = this.total_count;
      axios({
        // 处理文件流导出
        method: "post",
        url: `${process.env.VUE_APP_BASE_API}/api/stts_sign/outbillorder/expor`,
        data: obj,
        headers: {
          Token: getToken(),
        },
        responseType: "blob",
        exportFlag: true,
      }).then((res) => {
        this.llistLoading2 = false;
        console.log(res, "导出返回");
        if (res.data.type !== "application/vnd.ms-excel")
          return this.$message.error("导出失败,请检查参数");
        const blob = new Blob([res.data]);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${this.$route.meta.title}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
      // hear
    },
    // 获取营销中心列表
    getmarkentinglist(code, type) {
      typeorglist({ parentCode: code }).then((response) => {
        console.log(response);
        switch (type) {
          case 0:
            this.marketinglist = response.data;
            this.searchform.businessCode = "";
            this.searchform.regionCode = "";
            break;
          case 1:
            this.regionlist = response.data;
            this.searchform.businessCode = "";
            this.searchform.regionCode = "";
            break;
          case 2:
            this.businesslist = response.data;
            this.searchform.businessCode = "";
            break;

          default:
            break;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;

      this.searchform.startCreateTime = this.searchform.datelist == null ? "" : this.searchform.datelist[0];
      this.searchform.endCreateTime = this.searchform.datelist == null ? "" : this.searchform.datelist[1];
      this.searchform.startSginTime = this.searchform.datelist1 == null ? "" : this.searchform.datelist1[0];
      this.searchform.endSginTime = this.searchform.datelist1 == null ? "" : this.searchform.datelist1[1];
      signorderlist(obj).then((response) => {
        console.log(response);
        this.packdate(response.data.list);
        this.tableData = response.data.list;
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.currPage;
        this.listLoading = false;
      });
    },
    getterminalqrcodelist(row) {
      this.searchBoxcode.sginBillCode = row.sginBillCode;
      this.searchBoxcode.productCode = row.productCode;
      this.getboxtablelist()
    },
    getboxtablelist() {
      terminalqrcodelist(this.searchBoxcode).then((response) => {
        console.log(response);
        this.boxcodelist = response.data;
        this.Boxtotal_count = response.data.totalCount;
        // this.currentPage = response.data.currPage;
        this.dialogVisible = true;
      });
    },
    //分页跳转事件
    Boxcurrentchange(page) {
      this.searchBoxcode.page = page;
      this.getboxtablelist()
    },
    //分页每页显示条数事件
    Boxlimit(limit) {
      this.searchBoxcode.limit = limit;
      this.getboxtablelist()
    },
    // 拼装表格数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        obj[i].imglist = [];
        switch (obj[i].status) {
          case 0:
            obj[i].status = "未送达";
            break;
          case 1:
            obj[i].status = "已送达";
            break;
          case 2:
            obj[i].status = "已签收";
            break;
          default:
            break;
        }
      }
    },
    //搜索事件
    search() {
      this.searchform.page = 1;
      this.Tabledata(this.searchform);
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(page) {
      this.searchform.page = page;
      this.Tabledata(this.searchform);
    },
    //分页每页显示条数事件
    limit(limit) {
      this.searchform.limit = limit;
      this.search();
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit",
      });
    },
  },
};
</script>
<style scoped></style>
